import axios from 'axios'
import global_define from '../library/global/define'

// 检测是否为安卓环境
function isAndroidBrowser() {
    return /(Android)/i.test(window.navigator.userAgent);
}

const headers = {
    'Access-Control-Allow-Origin': global_define.access_control_allow_origin,
    'Access-Control-Allow-Headers': "x-requested-with,access-control-allow-origin,authorization,content-type,access-control-allow-headers,authorization,set-cookie,access-control-expose-headers,Content-Type,Content-Length,Authorization,Accept,X-Requested-With",
    'Access-Control-Allow-Credentials': 'true',
}

// 安卓环境下增加超时时间和重试机制
const axios_instance = axios.create({
    timeout: 100000,
    headers: headers,
    withCredentials: true,
    credentials: 'include',
    maxRedirects: 0,
    mode: 'cors',
    crossDomain: true,
    allowMethods: 'GET,HEAD,PUT,POST,DELETE,PATCH,OPTIONS',
    validateStatus: function(status) {
        return status >= 200 && status < 303;
    },
})

// 添加请求拦截器，处理安卓环境下的特殊情况
axios_instance.interceptors.request.use(
    function (config) {
        // 安卓环境下的请求优化
        if (isAndroidBrowser()) {
            // 确保Content-Type正确设置
            if (config.data instanceof FormData) {
                delete config.headers['Content-Type']; // 让浏览器自动设置
            }
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// 添加响应拦截器，处理安卓环境下的错误
axios_instance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        // 安卓环境下的错误处理优化
        if (isAndroidBrowser() && error.code === 'NETWORK_ERROR') {
            console.error('安卓网络错误，建议检查网络连接');
        }
        return Promise.reject(error);
    }
);

export default axios_instance